module.exports = "/_next/static/media/92493f7506f6272d2c769ee6bf5531b2.png";